/*
 * Frontend display parameters.
 */
export const PROGRESS_CHECK_MINIMUM_PROGRESS = 0.33;

export const PROGRESS_CHECK_PERIOD_MILLISECONDS = 10000;

export const PROGRESS_DISPLAY_PERCENTAGE_PRECISION = 0;

export const VISIBILITY_DELAY_MILLISECONDS = 5000;

export const CHALLENGE_ID_KEY = 'PoSTChallengeId';
